<template>
    <v-form class="pb-4" data-cy="description-general-form">
        <v-row no-gutters class="mt-4">
            <v-col cols="12" md="6">
                <v-combobox
                    v-model="formData.tags"
                    :label="$t('tags')"
                    multiple
                    clearable
                    chips
                    closable-chips
                    data-cy="hotel-tags"
                    hide-selected
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="ga-2">
            <v-btn color="primary" class="save-btn" :loading="isLoading" :disabled="isLoading" @click="save">
                {{ $t('save') }}
            </v-btn>
            <v-btn
                color="primary"
                class="cancel-btn"
                variant="text"
                data-cy="cancel"
                :disabled="isLoading"
                :to="{name: 'supplierProducts'}"
            >
                {{ $t('cancel') }}
            </v-btn>
        </v-row>
    </v-form>
</template>
<script setup lang="ts">
    const isLoading = ref<boolean>(false)
    const formData = ref<string[]>([])
    const hotelDescriptionId: string = inject('hotelDescriptionId', null)

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        if (hotelDescriptionId) await loadData()
    })

    async function loadData(): Promise<void> {
        try {
            isLoading.value = true
            formData.value = await $api.hotelTags.get(hotelDescriptionId)
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }

    const save = async (): Promise<void> => {
        try {
            isLoading.value = true
            delete formData.value.hotelId
            formData.value = await $api.hotelTags.put(hotelDescriptionId, formData.value)
            $toast.success(t('success_message.saved_successfully'))
        } catch (e) {
            $toast.error(e.msg || e?.errors?.[0]?.message || t('error_message.save_error'))
        } finally {
            isLoading.value = false
        }
    }
</script>
